(() => {
  const init = (root = document) => {
    root.querySelectorAll('iframe[data-pt-reco-src]').forEach((frame) => {
      if (frame.dataset.ptRecoWaiting) return;
      frame.dataset.ptRecoWaiting = 'true';
      const product = frame.closest('product-info') || document;
      const image = product.querySelector('.product__media-item.is-active .product__media img');
      let started = false;
      let fallback;
      const load = () => {
        if (started) return;
        started = true;
        clearTimeout(fallback);
        image?.removeEventListener('load', ready);
        image?.removeEventListener('error', ready);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!frame.isConnected || !frame.dataset.ptRecoSrc) return;
          frame.src = frame.dataset.ptRecoSrc;
          delete frame.dataset.ptRecoSrc;
        }));
      };
      const ready = () => load();
      if (!image || image.complete) load();
      else {
        image.addEventListener('load', ready, { once: true });
        image.addEventListener('error', ready, { once: true });
        fallback = setTimeout(load, 5000);
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
